import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/lead-gen/$")({
    beforeLoad: ({ params }) => {
        const rest = (params._splat ?? "").replace(/^\/+/, "");
        throw redirect({
            href: rest ? `/sales/${rest}` : "/sales/leads",
            replace: true,
        });
    },
});
